/**
 * Kyros header: mobile menu toggle + Escape to close + mega menu keyboard hint
 */
(function () {
  const openBtn = document.querySelector('[data-kyros-mobile-open]');
  const closeBtn = document.querySelector('[data-kyros-mobile-close]');
  const overlay = document.querySelector('[data-kyros-mobile-overlay]');
  if (!openBtn || !overlay) return;

  function openMobile() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    closeBtn && closeBtn.focus();
  }

  function closeMobile() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    openBtn && openBtn.focus();
  }

  openBtn.addEventListener('click', openMobile);
  closeBtn && closeBtn.addEventListener('click', closeMobile);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeMobile();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeMobile();
    }
  });

  document.querySelectorAll('[data-kyros-accordion-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !expanded);
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = expanded;
    });
  });
})();
